export const customerSignup = {
  title: 'Customer Registration',
  subtitle: 'Create your password for your account',
  
  // Account Info
  accountInfo: {
    title: 'Account Information',
    name: 'Name',
    email: 'Email'
  },
  
  // Form
  form: {
    password: 'Password',
    passwordPlaceholder: 'Minimum 6 characters',
    confirmPassword: 'Confirm Password',
    confirmPasswordPlaceholder: 'Password again',
    createAccount: 'Create Account',
    creating: 'Creating...'
  },
  
  // Messages
  messages: {
    passwordTooShort: 'Password must be at least 6 characters long',
    passwordMismatch: 'Passwords do not match',
    success: 'Registration successful! Redirecting...',
    emailInUse: 'This email address is already in use',
    error: 'An error occurred during registration'
  },
  
  // States
  states: {
    loading: 'Loading...',
    error: 'Error',
    success: 'Registration Successful!',
    successMessage: 'Your account has been created successfully. Redirecting to customer portal...'
  },
  
  // Errors
  errors: {
    invalidLink: 'Invalid registration link',
    expiredLink: 'The registration link has expired. Please request a new link from the administrator.',
    alreadyHasAccount: 'You already have a user account. Please log in!',
    validationError: 'An error occurred while validating the registration link'
  },
  
  // Footer
  footer: {
    hasAccount: 'Already have an account?',
    login: 'Log In'
  }
};
